module.exports = __webpack_public_path__ + "static/img/i-step3.fcbae263.png";